// 교직원관리 필드명 리스트
export const TeacherAttributes = Object({
  birthDay : '생년월일',
  branchSeq : '',
  createDate : '',
  eMail : '이메일',
  instituteName : '학원명',
  instituteSeq : '학원 seq',
  isLunar : '양력/음력',
  lastUpdateDate : '',
  majorCareer : '주요경력',
  mobilephone : '핸드폰 번호',
  name : '이름',
  password : 'password',
  photo : '사진',
  realJumin : '주민번호',
  status : '상태',
  subject : '전공',
  teacherCareer : '교사경력',
  teacherID : '교직원 ID',
  telephone : '전화번호',
  university : '출신학교',
  userID : 'ID',
  userType : '멤버 타입',
  zipCode : '우편번호',
  zipDetail : '주소세부',
  zipName : '주소'
})